<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Products</div>
            <div class="header-title">产品中心</div>
        </div>
        <!-- 产品中心 -->
        <div>
            <div class="w" style="padding: 60px 0;">
                <div>
                    <div class="text-center title">{{ info.fJ_ProductInfo!=null?info.fJ_ProductInfo.productName:"" }}</div>
                    <div class="text-center" style="margin-top: 10px;">{{info.fJ_ProductInfo!=null?info.fJ_ProductInfo.productNameEN:""  }}</div>
                </div>
                <div class="mt-3">
                    <!--  <img src="../../assets/img/banner-02.jpg" style="width: 100%;" alt="">-->
                    <div class="bgg">

                        <img :ref="prefix+info.fJ_ProductInfo.id" :src="http.ipAddress+info.fJ_ProductInfo.filePath"
                                style="width: 550px;" alt="" >
                        
                    </div>
                    <p style="margin-top: 10px;">
                        {{info.fJ_ProductInfo_Description.remark}}
                    </p>
                </div>
                <div>
                    <div class="border">
                        <div>
                            <div class="ttitle1">应用</div>
                            <div class="" style="margin-top: 10px;">Application</div>
                        </div>
                        <p class="pp" style="margin-top: 10px;">
                            {{info.fJ_ProductInfo_Description.application}}
                        </p>
                    </div>
                    <div class="border">
                        <div>
                            <div class="ttitle1">特点</div>
                            <div class="" style="margin-top: 10px;">Features</div>
                        </div> 
                        <p class="pp" style="white-space: pre-line"  v-html="info.fJ_ProductInfo_Description.features">
                          
                        </p>
                    </div>
                     <!--控制器规格表-->
                     <div class="border" v-if="info.fJ_ProductInfo.productType == 1">
                        <div>
                            <div class="ttitle1">规格</div>
                            <div class="" style="margin-top: 10px;">Specifications</div>
                        </div>
                        <div class="mt-3">
                            <el-table :data="info.fJ_ProductControlSpecs" border style="width: 100%">
                                <el-table-column prop="voltageRange" label="电池电压范围" width="180">
                                </el-table-column>
                                <el-table-column prop="maxWorkCurrent" label="最大工作电流" width="180">
                                </el-table-column>
                                <el-table-column prop="maxWorkTemperature" label="工作环境温度">
                                </el-table-column>
                                <el-table-column prop="storageTemperature" label="存储温度">
                                </el-table-column>
                                <el-table-column prop="workProtectTemperature" label="工作保护温度">
                                </el-table-column>
                                <el-table-column prop="workingHumidity" label="工作湿度">
                                </el-table-column>
                                <el-table-column prop="protectionGrade" label="防护等级">
                                </el-table-column>
                            </el-table>
                            
                        </div>
                    </div>
                    <!--控制器选型表-->
                    <div class="border"  v-if="info.fJ_ProductInfo.productType == 1">
                        <div>
                            <div class="ttitle1">选型表</div>
                            <div class="" style="margin-top: 10px;">Type</div>
                        </div>
                        <div class="mt-3">
                            <el-table :data="info.fJ_ProductControlTypes" border style="width: 100%">
                                <el-table-column prop="model" label="型号">
                                </el-table-column>
                                <el-table-column prop="voltage" label="电池电压（V）">
                                </el-table-column>
                                <el-table-column prop="current1" label="1分钟额定电流（有效值A）">
                                </el-table-column>
                                <el-table-column prop="s1Current2" label="S1-2分钟额定电流（有效值A）">
                                </el-table-column>
                                <!-- <el-table-column prop="name5" label="S1-2分钟额定电流（有效值A）">
                                </el-table-column> -->
                                <el-table-column prop="s2Current60" label="S2-60分钟额定电流（有效值A）">
                                </el-table-column>
                                <el-table-column prop="s3PeakValue" label="S3-10秒峰值电流（有效值A）">
                                </el-table-column>
                                <el-table-column prop="size" label="结构尺寸">
                                </el-table-column>
                                <el-table-column prop="contactor" label="接触器">
                                </el-table-column>
                                <!-- <el-table-column prop="name10" label="备注">
                                </el-table-column> -->
                            </el-table>
                            <div class="pp1">{{info.fJ_ProductInfo_Description.ettribute1}}</div>
                            <!-- 添加备注 -->
                            <!-- <div class="pp1">备注：1.S2-60分钟额定电流，需要增加额外散热条件。2.-P(Pro)可选双芯片款。3.功能拓展位（可多位，可缺省）：如-R=旋变解码，-C=CAN通信，-U=串口通信，-I=CAN隔离。
                            </div> -->
                        </div>
                    </div>
                    <!--仪表规格表-->
                    <div class="border" v-if="info.fJ_ProductInfo.productType!= 1">
                        <div>
                            <div class="ttitle1">规格</div>
                            <div class="" style="margin-top: 10px;">Specifications</div>
                        </div>
                        <div class="mt-3">
                            <el-table :data="info.fJ_ProductMeterSpecs" border style="width: 100%">
                                <el-table-column prop="workVoltage" label="工作电压范围">
                                </el-table-column>
                                <el-table-column prop="ratedVoltage" label="额定工作电压">
                                </el-table-column>
                                <el-table-column prop="ratedCurrent" label="额定工作电流">
                                </el-table-column>
                                <el-table-column prop="workTemperature" label="工作温度">
                                </el-table-column>
                                <el-table-column prop="storageTemperature" label="存储温度">
                                </el-table-column>
                                <el-table-column prop="workingHumidity" label="工作湿度">
                                </el-table-column>
                                <el-table-column prop="protectionGrade" label="防护等级">
                                </el-table-column>
                                <el-table-column prop="rfCommunication" label="射频通讯">
                                </el-table-column>
                                <el-table-column prop="lcdScreen" label="液晶屏">
                                </el-table-column>
                                <el-table-column prop="communicateType" label="通讯方式">
                                </el-table-column>
                                <!-- <el-table-column prop="name11" label="CAN">
                                </el-table-column>
                                <el-table-column prop="name12" label="WIFI">
                                </el-table-column>
                                <el-table-column prop="name13" label="BLE">
                                </el-table-column> -->
                            </el-table>
                        </div>
                    </div>
                    <!--仪表选型表-->
                    <div class="border" v-if="info.fJ_ProductInfo.productType != 1">
                        <div>
                            <div class="ttitle1">选型表</div>
                            <div class="" style="margin-top: 10px;">Type</div>
                        </div>
                        <div class="mt-3">
                            <el-table :data="info.fJ_ProductMeterTypes" border style="width: 100%">
                                <el-table-column prop="model" label="型号" width="250">
                                </el-table-column>
                                <el-table-column prop="productNum" label="品号" width="250">
                                </el-table-column>
                                <el-table-column prop="ratedVoltage" label="额定电压">
                                </el-table-column>
                                <el-table-column prop="remoteMonitorDesc" label="是否支持远程监控功能">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            //testText:" FJ-G1系列产品为交流感应电机控制器，采用先进的控制算法，有效提高电动车辆的可操作性和舒适性并可借助FJ运程监控系统(选搭配FJ-M1仪表)，实现电动车辆的远程管理、报警预警、参数查询与修改、运行数据分析等车联网功能，同时配备蓝牙、4G功能要加便于调试及远程控制。",
            // tableData: [{
            //    name1: '32-60V ',
            //    name2: '400A ',
            //    name3: '-40C-50℃  ',
            //    name4: '-40C-85℃',
            //    name5: '85℃',
            //    name6: '<85%',
            //    name7: 'IP67',
            //}, {
            //    name1: '32-60V ',
            //    name2: '400A ',
            //    name3: '-40C-50℃  ',
            //    name4: '-40C-85℃',
            //    name5: '85℃',
            //    name6: '<85%',
            //    name7: 'IP67',
            //}],
            //tableData1: [{
            //    name1: 'FJ-D1-24-S  ',
            //    name2: '24',
            //    name3: '250/300/350',
            //    name4: '125/150/175',
            //    name5: 'S',
            //}, {
            //    name1: 'FJ-D1-24-S  ',
            //    name2: '24',
            //    name3: '250/300/350',
            //    name4: '125/150/175',
            //    name5: 'S',
            //}],
            prefix:"product",
            switch:1,
            info:{}
        }
    },
    methods: {
        
    },
    mounted() {
        debugger
        console.log('indexindexindex', this.$route.query.switch);
        if(this.$route.query.switch) this.switch =  this.$route.query.switch
        let index =  this.$route.query.index;
        // if(this.switch == 1) {
        //     console.log(controllerData[index]);
        //     this.info = controllerData[index]
        // }else {
        //     console.log(meterData[index]);
        //     this.info = meterData[index]
        // }
        let vType= this.$route.query.type;
                if(vType!=null&&vType=="app"){
                    this.$emit("hideHead");
                }
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetProductInfoDetail",JSON.stringify({productid:parseInt(index,10),lanuage:0})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
            that.info=objResult.data;
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });



        
    }
}
</script>

<style scoped>
.header {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100%;
}

.bgg{
    background: url('../../assets/img/sdhh.png') no-repeat;
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.products-item {
    width: 30%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 30px;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}

.mt-3 {
    margin-top: 30px;
    line-height: 2.0;
    
}

.border {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #eee;
}

.ttitle1 {
    font-size: 16px;
    font-weight: 700;
}

.pp {
    font-size: 16px;
    line-height: 2.0;
}

.pp1 {
    font-size: 13px;
    line-height: 2.0;
}
</style>


// WEBPACK FOOTER //
// src/views/products/detail.vue